<script>
export default {
  created() {
    window.location.href = "/";
  },
};
</script>
